import styled from "styled-components";

export const Icon = styled.i`
  margin-left: auto;
  margin-right: 2rem;
  color: ${(props) => props.color || props.theme.theme.TEXT.PRIMARY} !important;
`;
